<div class="map-wrapper">
  <div class="map-input-overlay">
    <div class="flex-row">
      <mat-form-field class="flex-col-49 search-input" subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Suche</mat-label>
        <input matInput placeholder="Adresse eingeben" [matAutocomplete]="auto" (input)="onAddressInput($event)" />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayLabel"
          (optionSelected)="onAddressSelected($event.option.value.placeId)">
          @for (option of addressHits(); track option.placeId) {
            <mat-option [value]="option">
              {{ option.label }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
  <div class="map-button-overlay">
    <button
      type="button"
      class="bricks-button button-fn button-icon-left"
      (click)="lockPin(); this.trackEvent()"
      [disabled]="!isPinValid()">
      <bricks-icon>bricks-pin-destination</bricks-icon>
      <span>Standort festlegen</span>
    </button>
  </div>
  <div id="map{{ resourceId() }}" class="map-content"></div>
</div>
